import type { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/subject', // 频道专区  已停用现在APP中使用的是客服端开发的
    name: 'Subject',
    meta: {
      title: '',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/subject/index.vue'),
  },
]

export default routes
